{
    "ShowMore": "Show more",
    "ShowLess": "Show less",
    "NAME": "LanguageSnackbar"
}